var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "search-form" },
    [
      _c(
        "el-form",
        {
          ref: "searchForm",
          attrs: {
            model: _vm.formData,
            inline: true,
            "label-width": "labelWidth + 'px'",
            size: "small",
          },
        },
        [
          _vm._l(_vm.displayFields, function (field, index) {
            return _c(
              "el-form-item",
              {
                key: field.prop,
                attrs: { label: field.label, prop: field.prop },
              },
              [
                field.type === "input" || !field.type
                  ? _c("el-input", {
                      staticStyle: { width: "180px" },
                      attrs: {
                        placeholder:
                          field.placeholder || "请输入" + field.label,
                        clearable: field.clearable !== false,
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.handleSearch.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.formData[field.prop],
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, field.prop, $$v)
                        },
                        expression: "formData[field.prop]",
                      },
                    })
                  : field.type === "select"
                  ? _c(
                      "el-select",
                      {
                        staticStyle: { width: "180px" },
                        attrs: {
                          placeholder:
                            field.placeholder || "请选择" + field.label,
                          clearable: field.clearable !== false,
                        },
                        model: {
                          value: _vm.formData[field.prop],
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, field.prop, $$v)
                          },
                          expression: "formData[field.prop]",
                        },
                      },
                      _vm._l(field.options, function (opt) {
                        return _c("el-option", {
                          key: opt.value,
                          attrs: { label: opt.label, value: opt.value },
                        })
                      }),
                      1
                    )
                  : field.type === "date"
                  ? _c("el-date-picker", {
                      staticStyle: { width: "180px" },
                      attrs: {
                        type: "date",
                        placeholder: field.placeholder || "请选择日期",
                        "value-format": "yyyy-MM-dd",
                      },
                      model: {
                        value: _vm.formData[field.prop],
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, field.prop, $$v)
                        },
                        expression: "formData[field.prop]",
                      },
                    })
                  : field.type === "daterange"
                  ? _c("el-date-picker", {
                      staticStyle: { width: "380px" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "yyyy-MM-dd",
                      },
                      model: {
                        value: _vm.formData[field.prop],
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, field.prop, $$v)
                        },
                        expression: "formData[field.prop]",
                      },
                    })
                  : field.type === "time"
                  ? _c("el-time-select", {
                      staticStyle: { width: "180px" },
                      attrs: { placeholder: field.placeholder || "请选择时间" },
                      model: {
                        value: _vm.formData[field.prop],
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, field.prop, $$v)
                        },
                        expression: "formData[field.prop]",
                      },
                    })
                  : field.type === "number"
                  ? _c("el-input-number", {
                      staticStyle: { width: "180px" },
                      attrs: {
                        min: field.min !== undefined ? field.min : undefined,
                        max: field.max !== undefined ? field.max : undefined,
                      },
                      model: {
                        value: _vm.formData[field.prop],
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, field.prop, $$v)
                        },
                        expression: "formData[field.prop]",
                      },
                    })
                  : field.type === "cascader"
                  ? _c("el-cascader", {
                      staticStyle: { width: "220px" },
                      attrs: {
                        options: field.options,
                        placeholder: field.placeholder || "请选择",
                        props: field.props || {},
                        clearable: "",
                      },
                      model: {
                        value: _vm.formData[field.prop],
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, field.prop, $$v)
                        },
                        expression: "formData[field.prop]",
                      },
                    })
                  : _vm._t("field-" + field.prop, null, {
                      field: field,
                      value: _vm.formData[field.prop],
                    }),
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "search-actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleSearch },
                },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh" },
                  on: { click: _vm.handleReset },
                },
                [_vm._v("重置")]
              ),
              _vm._v(" "),
              _vm.showToggle && _vm.fields.length > _vm.defaultFields
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: { click: _vm.toggleExpand },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.isExpanded ? "收起" : "展开") +
                          "\n        "
                      ),
                      _c("i", {
                        class: _vm.isExpanded
                          ? "el-icon-arrow-up"
                          : "el-icon-arrow-down",
                      }),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }